import React from 'react';
import { connect } from 'react-redux';
import Results from '../results';
import Error from './Error';

const UploadStatus = ({
  ready,
  error,
  errors,
  status,
  previews,
}) => {
  if (ready) {
    if (error || status.includes('error')) {
      return (
        <div className="w-100">
          <Error status={error || status} />
        </div>
      );
    }

    if (errors && errors.includes('Could not process the file. line contains NULL byte')) {
      return (
        <div className="w-100">
          <Error status={errors[0]} />
        </div>
      );
    }

    if (!status) {
      return <div className="text-muted">No files uploaded.</div>;
    }
    return <Results />;
  }
  return (
    <div className="w-100">
      <h6 className="text-center text-capitalize">{status}</h6>
      {previews}
    </div>
  );
};

const mapStateToProps = (store) => ({
  ready: store.batch.ready,
  error: store.batch.error,
  errors: store.batch.errors,
  status: store.batch.status,
});

export default connect(mapStateToProps)(UploadStatus);
